import { atom } from 'jotai';

import type { User } from '@supabase/supabase-js';

export const userAtom = atom<User | null>(null);
export const currentUserIdAtom = atom((get) => get(userAtom)?.id);

const CLIENT_SESSION_KEY = 'elva.client_session_id';

export const currentSessionIdAtom = atom((get) => {
    const userId = get(currentUserIdAtom) ?? 'guest';
    const key = `${CLIENT_SESSION_KEY}:${userId}`;

    const existing = sessionStorage.getItem(key);
    if (existing) return existing;

    const newId = `${userId}:${window.crypto.randomUUID()}`;
    sessionStorage.setItem(key, newId);
    return newId;
});
